
<template>

<div>
    <!-- <el-tab-pane label="分析" name="first" :lazy="true"> -->
      <analysis ref="clue-management"></analysis>
    <!-- </el-tab-pane>
    <el-tab-pane label="埋点" name="second">
      <setting ref="clue-management"></setting>
    </el-tab-pane> -->
</div>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import analysis from './analysis'

export default {
  name: 'clue-tab-index',
  extends: BasicPager,
  data () {
    return {
      isAdmin: false,
      activeName: 'first'
    }
  },
  components: {
    analysis
  }
}

</script>
